import { F as useContentT, p as jsxRuntimeExports, T as MathJax } from "./doenetml-NmXDuMHr.js";
import React__default, { useRef } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
/* empty css                   */
import { c as calculateValidationState, u as useSubmitActionWithDelay, a as createCheckWorkComponent } from "./useSubmitActionWithDelay-CAA7rbjf.js";
import { a as addValidationStateToShortDescription } from "./validationState-DI_lxk1a.js";
import { D as DescriptionPopover } from "./Description-G0B1pi98.js";
const fractionInput = React__default.memo(function FractionInput(props) {
  let { id, SVs, actions, children, callAction } = useDoenetRenderer(props);
  const tContent = useContentT();
  let validationState = useRef("unvalidated");
  if (SVs.hidden) {
    return null;
  }
  validationState.current = calculateValidationState(SVs);
  const { isPending, submitActionWithPending } = useSubmitActionWithDelay({
    actionKey: "submitAnswer",
    actions,
    callAction,
    validationState: validationState.current,
    justSubmitted: SVs.justSubmitted
  });
  const checkWorkComponent = createCheckWorkComponent(
    SVs,
    id,
    validationState.current,
    submitActionWithPending,
    SVs.forceFullCheckWorkButton,
    isPending,
    tContent
  );
  let label = SVs.label;
  const hasLabel = typeof SVs.label === "string" ? SVs.label.trim() !== "" : !!SVs.label;
  const labelId = `${id}-label`;
  if (SVs.labelHasLatex) {
    label = /* @__PURE__ */ jsxRuntimeExports.jsx(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true, children: label });
  }
  let shortDescription = SVs.shortDescription || void 0;
  const externalLabelRendererIds = SVs.externalLabelRendererIds ?? [];
  const groupLabelledByIds = [
    hasLabel ? labelId : null,
    ...externalLabelRendererIds
  ].filter(Boolean).join(" ");
  if (SVs.colorCorrectness) {
    shortDescription = addValidationStateToShortDescription(
      validationState.current,
      shortDescription,
      tContent
    );
  }
  const descriptionChild = SVs.descriptionChildInd !== void 0 && SVs.descriptionChildInd !== -1 && children[SVs.descriptionChildInd];
  let descriptionId = void 0;
  let description = null;
  if (descriptionChild) {
    descriptionId = `${id}-description-content`;
    description = /* @__PURE__ */ jsxRuntimeExports.jsx(DescriptionPopover, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: descriptionId, children: descriptionChild }) });
  }
  const labelComponent = hasLabel ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      id: labelId,
      style: {
        marginInlineEnd: SVs.labelPosition === "end" ? void 0 : "5px",
        marginInlineStart: SVs.labelPosition === "end" ? "5px" : void 0
      },
      children: label
    }
  ) : null;
  const fractionInputRow = /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "span",
    {
      style: {
        display: "inline-flex",
        // Vertically center the check-work button next to the fraction
        // rather than pinning it to the top.
        alignItems: "center",
        verticalAlign: "middle"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fraction-input", id, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "table",
          {
            "aria-labelledby": groupLabelledByIds || void 0,
            "aria-label": !groupLabelledByIds ? shortDescription : void 0,
            "aria-description": groupLabelledByIds ? shortDescription : void 0,
            "aria-details": descriptionId,
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tbody", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "fractionNumerator", children: children[0] }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "fractionVinculum" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "fractionDenominator", children: children[1] }) })
            ] })
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { marginInlineEnd: "4px" } }),
        checkWorkComponent,
        description
      ]
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        display: "inline",
        margin: "0 4px"
      },
      id: `${id}-container`,
      children: SVs.labelPosition === "end" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        fractionInputRow,
        labelComponent
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        labelComponent,
        fractionInputRow
      ] })
    }
  ) });
});
export {
  fractionInput as default
};
